import React, { Component } from "react";
import PropTypes from "prop-types";
import BufeKinalatListaContent from "./BufeKinalatListaContent";
import CustomTooltip from '../../../components/Tooltip/CustomTooltip';
import getTooltip from '../WeboldalakTooltips';

class BufeKinalatListaBase extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let cardStyle = {
      padding: 20
    };

    return (
      <div>
        <div className="animated fadeIn">
          <div className="card">
            <div className="card-header">
              {"Büfé kínálat"}
              <CustomTooltip text={getTooltip('bufekinalat')} id="bufekinalatTT" />
            </div>
            <div className="row" style={cardStyle}>
              <div className="col-md-12">
                <BufeKinalatListaContent {...this.props} globals={this.props.globals} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

BufeKinalatListaBase.propTypes = {
  route: PropTypes.object,
  globals: PropTypes.object
};

export default BufeKinalatListaBase;
